import type { AccountStatus } from '@/api/types'

export const ACCOUNT_STATUS_LABELS: Record<AccountStatus, string> = {
  trialing: 'Trial',
  active: 'Active',
  past_due: 'Past due',
  suspended: 'Suspended',
  canceled: 'Canceled',
}

export function accountStatusLabel(status: AccountStatus): string {
  return ACCOUNT_STATUS_LABELS[status]
}
